import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './design-system/ThemeProvider';
import { observeAnalyticsRoutes } from './firebase/analytics';

// The design system is the first stylesheet in: every screen builds on it.
// It also brings in the curated icon layer (design-system/icons.css), so there
// is no CDN dependency and no Font Awesome import anywhere else.
import './design-system/index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([{ path: '*', element: <ThemeProvider><App /></ThemeProvider> }]);
observeAnalyticsRoutes(router);
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
